import { Button } from '@fluentui/react-components';
import { PlugDisconnected24Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { useRuntime } from '@/app/providers/runtime-provider';
import { FullPageState } from '@/shared/components/full-page-state';

/** Shown when GET /platform/me fails (service down): plain language and a retry. */
export function SessionUnavailable() {
  const { t } = useTranslation(['backoffice', 'common']);
  const { sessionStore } = useRuntime();
  return (
    <FullPageState
      role="alert"
      icon={<PlugDisconnected24Regular />}
      title={t('backoffice:unavailable.title')}
      actions={
        <Button
          appearance="primary"
          onClick={() => {
            void sessionStore.bootstrap();
          }}
        >
          {t('common:actions.retry')}
        </Button>
      }
    >
      {t('backoffice:unavailable.body')}
    </FullPageState>
  );
}
